import { useEffect } from 'react';

/** Browser tab title and icon for one event. Restores the previous icon on leaving the page. */
export function usePageTab({ title, icon }) {
  useEffect(() => {
    if (title) document.title = title;
    if (!icon) return undefined;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    const previous = link.getAttribute('href');
    link.href = icon;
    return () => {
      if (previous) link.setAttribute('href', previous);
    };
  }, [title, icon]);
}
